var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSwitchHorizontalSvgrepoCom = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "800px",
  height: "800px",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 10L21 7M21 7L18 4M21 7H7M6 14L3 17M3 17L6 20M3 17H17",
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgSwitchHorizontalSvgrepoCom as ReactComponent };
export default __webpack_public_path__ + "static/media/switch-horizontal-svgrepo-com.ab3bb1a54862beefad4c02c608039d1e.svg";